// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"253c21f4","195":"c5159152","311":"f5ea4363","569":"ad73a4a5"}[chunkId] + ".chunk.js";
};